import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from 'redux';
import moment from 'moment';
import { IStore } from '../../../../redux/store';
import { inspectorSelectors } from 'redux/app/vessel/inspector';
import { vesselSelectors } from 'redux/app/vessel';
import { TTableBallastTank } from 'redux/app/ballast/@types';
import { ballastSelectors } from 'redux/app/ballast';

type OwnProps = {
	vesselId: string;
};
type BallastTankOperationsCoverPageProps = PropsFromRedux & OwnProps;
function BallastTankOperationsCoverPage(
	props: BallastTankOperationsCoverPageProps
) {
	const { dateRange,
		vesselName,
		imoNumber,
		distinctiveNumberOrLetters,
		ballastTanks,
		selectedBallastTank,
	} = props;

	function getTankCapacity(tankCode: string) {
		let filteredTank = ballastTanks.filter(
			(tank: TTableBallastTank) => tank.value === tankCode
		);
		if (filteredTank) {
			return filteredTank[0].capacity;
		}
	}
	return (
		<div>
			{/* First Page */}
			<div className="flex flex-col justify-between px-8 py-4 mb-2">
				<div className="mx-0 my-24 text-xl font-medium text-center">
					<h3 className="uppercase">Ballast Tank Operations</h3>
				</div>
				<div className="flex justify-center mt-8 mb-32">
					<div className="w-2/3 mt-2.5">
						<div
							className="flex items-center mb-4"
							style={{ fontSize: '1.125rem' }}
						>
							<p className="mb-0 mr-2 min-w-fit">Name of ship:</p>
							<p className="inline-block px-3 text-[#808080] border-b border-dashed text-sm border-[#808080] w-full mb-0">
								{vesselName}
							</p>
						</div>
						<div
							className="flex items-center mb-4"
							style={{ fontSize: '1.125rem' }}
						>
							<p className="mb-0 mr-2 min-w-fit">
								Distinctive number or letters:
							</p>
							<p className="inline-block px-3 text-[#808080] border-b border-dashed text-sm border-[#808080] w-full mb-0 self-end">
								{distinctiveNumberOrLetters}
							</p>
						</div>
						<div
							className="flex items-center mb-4"
							style={{ fontSize: '1.125rem' }}
						>
							<p className="mb-0 mr-2 min-w-fit">IMO Number:</p>
							<p className="inline-block px-3 text-[#808080] border-b border-dashed text-sm border-[#808080] w-full mb-0">
								{imoNumber}
							</p>
						</div>

						<div
							className="flex items-center mb-4"
							style={{ fontSize: '1.125rem' }}
						>
							<p className="mb-0 mr-2 min-w-fit">
								Gross tonnage:
							</p>
							<p className="inline-block px-3 text-[#808080] border-b border-dashed text-sm border-[#808080] w-full mb-0 self-end">
								{props?.tonnage?.grossTonnage || ''}
							</p>
						</div>
						<div
							className="flex items-center justify-between mb-4"
							style={{ fontSize: '1.125rem' }}
						>
							<div
								style={{ width: '54%' }}
								className="flex items-center mb-2"
							>
								<p className="mr-2 min-w-fit">Period from :</p>
								<p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 text-sm">
									{dateRange?.startDate &&
										moment(dateRange?.startDate).format(
											'DD-MM-yyyy'
										)}{' '}
								</p>
							</div>
							<div
								style={{ width: '45%' }}
								className="flex items-center mb-2"
							>
								<p className="mr-2 min-w-fit">to :</p>
								<p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 text-sm">
									{dateRange?.endDate &&
										moment(dateRange?.endDate).format(
											'DD-MM-yyyy'
										)}
								</p>
							</div>
						</div>
						<div
							className="flex items-center mb-4"
							style={{ fontSize: '1.125rem' }}
						>
							<p className="mr-2 min-w-fit mb-0">Working language of the ship:</p>
							<p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 text-sm">
								English
							</p>
						</div>
						{selectedBallastTank &&
							selectedBallastTank.length > 3 &&
							selectedBallastTank !== 'All Tanks' ? (
							<>
								<div
									className="flex items-center mb-4"
									style={{ fontSize: '1.125rem' }}
								>
									<p className="mr-2 min-w-fit mb-0">
										Tank ID
									</p>
									<p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 text-sm">
										{selectedBallastTank}
									</p>
								</div>
								<div
									className="flex items-center mb-4"
									style={{ fontSize: '1.125rem' }}
								>
									<p className="mr-2 min-w-fit mb-0">
										Tank Capacity
									</p>
									<p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 text-sm">
										{getTankCapacity(selectedBallastTank)}
									</p>
								</div>
							</>
						) : null}
					</div>
				</div>
			</div>
		</div>
	);
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const inspectorStore = inspectorSelectors._getStore(store);
	const ballastStore = ballastSelectors._getStore(store);
	const dateRange = inspectorSelectors.getDateRange(inspectorStore);
	const vesselStore = vesselSelectors._getStore(store);
	const vesselInfo = vesselSelectors.getVesselById(
		ownProps.vesselId,
		vesselSelectors.getVessels(vesselStore)
	);
	const ballastTanks = ballastSelectors.getBallastTanks(ballastStore);
	const selectedBallastTank =
		ballastSelectors.getSelectedBallastTankForTableLogs(ballastStore);
	return {
		dateRange,
		vesselName: vesselInfo.vesselName,
		imoNumber: vesselInfo.imoNumber,
		tonnage: vesselInfo.tonnage,
		distinctiveNumberOrLetters: vesselInfo?.distinctiveNumberOrLetters,
		ballastTanks,
		selectedBallastTank
	};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(BallastTankOperationsCoverPage);
